import { Select } from 'antd';
import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import DatePicker from 'antd/lib/date-picker';
import Form, { FormComponentProps } from 'antd/lib/form';
import Icon from 'antd/lib/icon';
import Input from 'antd/lib/input';
import InputNumber from 'antd/lib/input-number';
import TextArea from 'antd/lib/input/TextArea';
import message from 'antd/lib/message';
import Modal from 'antd/lib/modal';
import Row from 'antd/lib/row';
import Upload from 'antd/lib/upload';
import moment from 'moment';
import * as React from 'react';
import injectSheet from 'react-jss';
import { connect, ConnectedProps } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { setPrevPagination } from 'src/actions/bookingInquiryActions';
import { confirmBooking, extractDODetails } from 'src/api/booking';
import { fileUploadOnS3 } from 'src/api/inquiry';
import { getS3Links, uploadToS3 } from 'src/api/invoice';
import { uploadImageToS3 } from 'src/api/salesorder';
import RadioGroup from 'src/components/common/CommonSelect/RadioGroup';
import LocationPinIcon from 'src/components/common/icons/LocationPinIcon';
import { buttonStyle } from 'src/Library/CommonStyles';
import { getDateValue, isValidArray } from 'src/Library/Helper';
import { StyleProps, valueof } from 'src/Library/Types';
import { EventCategories, sendEvent } from 'src/utils/gaService';
import { downloadS3Url, getFileExtension } from 'src/utils/utils';
import { InquiryModes } from '../InquiryUtils';
import { carrierListForDOExtraction, MODE_SUPPORTING_AUTO_TRACKING, modeWiseDefaultUndisclosedCarrierCode, trackingProviders } from './BookingUtils';
import Protip from './Protip';
import { tokens } from 'src/design-system';
import Asterisk from 'src/components/common/Asterisk';

const BOOKING_POC_FIELD_LIST = ['name', 'phone', 'email', 'yardDetails'];
const FormItem = Form.Item;

const styles = theme => ({
  hintHeader: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#262626',
    width: '18%',
  },
  hintHeaderLess: {
    fontSize: `${tokens.fontSize.small}px`,
    fontWeight: tokens.fontWeight.semibold,
    color: '#262626',
    width: '36%',
  },

  pairStyle: {
    display: 'flex',
    alignItems: 'center',
    '& .ant-form-item': {
      marginBottom: 0,
    },
    marginTop: '6px',
  },
  parent: {
  },
  modal: {
    minWidth: '1000px',
    width: '100% !important',
    top: 0,
    '& .ant-modal-body': {
      padding: '14px 24px',
    },
    '& .ant-modal-footer': {
      padding: '14px 32px',
    },
  },
  label: {
    fontSize: `${tokens.fontSize.h3}px`,
    color: '#424242',
    fontWeight: tokens.fontWeight.semibold,
    marginTop: '14px',
  },
  detailsRow: {
    marginBottom: '20px',
  },
  submitButton: {
    ...buttonStyle(tokens.colors.bgWhite, tokens.colors.primary, '1px solid #1890FF'),
    padding: '0px 26px',
    marginRight: '50px',
  },
  trackingProviderRadio: {
    marginTop: '6px',
    marginBottom: '0px',
    paddingRight: '20px',
    fontWeight: tokens.fontWeight.semibold,
    fontSize: `${tokens.fontSize.small}px`,
    color: tokens.colors.textSecondary,
    '& .ant-form-item-control': {
      '& .ant-radio-wrapper': {
        paddingRight: '20px',
        fontWeight: tokens.fontWeight.semibold,
        color: tokens.colors.textSecondary,
      },
    },
  },
});

//keep in sync with jsw-backend/booking.types.ts
export const BOOKING_FORM_FIELDS = {
	bookingNumber: 'bookingNumber', // FCL LCL AIRCARGO
	bookingNote: 'bookingNote', // FCL LCL(cartingOrder) AIRCARGO
	containerCount: 'containerCount', // FCL LCL
	houseBl: 'houseBl', // FCL LCL
	VGMCutOff: 'VGMCutOff', // FCL LCL
	gateInCutOff: 'gateInCutOff', // FCL LCL
	documentCutOff: 'documentCutOff', // FCL LCL AIRCARGO
	siCutOff: 'siCutOff', // FCL LCL
	etd: 'etd', // FCL LCL AIRCARGO | DOMESTIC (Delivery Date)
	eta: 'eta', // FCL LCL AIRCARGO | DOMESTIC (Pickup Date)
	billValidity: 'billValidity', // FCL LCL AIRCARGO
	gateOpenDate: 'gateOpenDate', // FCL LCL AIRCARGO
	// portCutOff : 'portCutOff', // same as gateInCutOff
	handoverCutOff: 'handoverCutOff', // AIRCARGO
	// carrierCode : 'carrierCode', Always mandatory FCL LCL AIRCARGO
	name: 'name', // FCL LCL AIRCARGO
	phone: 'phone', // FCL LCL AIRCARGO
	email: 'email', // FCL LCL AIRCARGO
	yardDetails: 'yardDetails', // FCL LCL(cfsLocation)
	houseAWB: 'houseAWB', // AIRCARGO same as houseBl
	// TRAILER - NOT SUPPORTED FOR getOrganisationSettingsForInquiry.custom_mandatory_fields_in_booking
	truckNumber: 'truckNumber', // TRAILER - NOT SUPPORTED
	driverName: 'driverName', // TRAILER - NOT SUPPORTED
	driverPhoneNo: 'driverPhoneNo', // TRAILER - NOT SUPPORTED
	driverLicense: 'driverLicense', // TRAILER - NOT SUPPORTED
  purchaseOrder: 'purchaseOrder', // DOMESTIC
} as const;
export type BookingFormFields = valueof<typeof BOOKING_FORM_FIELDS>;

interface IBookingFFModalProps extends PropsFromRedux, FormComponentProps, StyleProps<typeof styles> {
  inquiryMode: InquiryModes;
  handleClose: () => void;
  bookingData: {
    // disableMandatoryFieldsInBooking: any;
    customMandatoryFieldsInBooking: Array<BookingFormFields>;
    hidePocDetailsInBooking?: boolean; 
    inttraDODetails: any;
    chargeDetails: any;
    bookingDetails: any;
  };
  isBooking: any;
  bookingId: any;
  isVisible: any;
  isProcessBookingForm: any;
  handleBack: any;
}

class BookingFFModal extends React.Component<IBookingFFModalProps, any> {

  state: any = {
    isSaving: false,
    protip: false,
    doExtractedValues: {},
    fileList: [],
    s3Links: {},
    uploadingLicense: false,
    licenseFile: undefined,
    licenseFileUrl: undefined,
  };

  checkIsCustomMandatory(field: BookingFormFields) {
    const { bookingData: { customMandatoryFieldsInBooking } } = this.props;
    if (customMandatoryFieldsInBooking){
      return customMandatoryFieldsInBooking.includes(field);
    }
    return null;
  }

  //todo: migrate to new-shipment.constants.ts/ShipmentFormFields format
  checkIsMandatory(field: BookingFormFields) {
    const { inquiryMode, bookingData : { customMandatoryFieldsInBooking } } = this.props;
    
    // Skip validation for hidden fields
    if (this.props.bookingData?.hidePocDetailsInBooking && BOOKING_POC_FIELD_LIST.includes(field))
      return false;
    
    if (inquiryMode !== InquiryModes.DOMESTIC && inquiryMode !== InquiryModes.RPTL && customMandatoryFieldsInBooking){
      return !!this.checkIsCustomMandatory(field);
    }
    const defaultMandatoryFieldsFCLLCL: Array<BookingFormFields> = [
      BOOKING_FORM_FIELDS.bookingNumber,
      BOOKING_FORM_FIELDS.bookingNote,
      BOOKING_FORM_FIELDS.gateInCutOff,
      BOOKING_FORM_FIELDS.siCutOff,
      BOOKING_FORM_FIELDS.eta,
      BOOKING_FORM_FIELDS.billValidity,
      BOOKING_FORM_FIELDS.name,
      BOOKING_FORM_FIELDS.phone,
      BOOKING_FORM_FIELDS.yardDetails,
    ];
    const defaultMandatoryFieldsAIRCARGO: Array<BookingFormFields> = [
      BOOKING_FORM_FIELDS.bookingNumber,
      BOOKING_FORM_FIELDS.billValidity,
      BOOKING_FORM_FIELDS.eta,
      BOOKING_FORM_FIELDS.name,
      BOOKING_FORM_FIELDS.phone,
    ];
    const defaultMandatoryFieldsDOMESTIC: Array<BookingFormFields> = [
      BOOKING_FORM_FIELDS.bookingNumber,
      BOOKING_FORM_FIELDS.purchaseOrder,
      BOOKING_FORM_FIELDS.eta,
      BOOKING_FORM_FIELDS.etd,
    ];
    if (inquiryMode === InquiryModes.FCL || inquiryMode === InquiryModes.LCL){
      return defaultMandatoryFieldsFCLLCL.includes(field);
    }
    if (inquiryMode === InquiryModes.AIRCARGO){
      return defaultMandatoryFieldsAIRCARGO.includes(field);
    }
    if (inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL){
      return defaultMandatoryFieldsDOMESTIC.includes(field);
    }
    return false;
  }

  disabledDateSailing = (current: any) => {
    return current && current < moment().endOf('day').subtract(1, 'day');
  }

  disabledBillValidity = (current) => {
    return current && current < moment().endOf('day');
  }

  handleModalClose = (sendGAEvent = true) => {
    sendGAEvent && sendEvent(
      EventCategories.INQUIRY_BOOKING_FF,
      'Process Booking - Cancel',
    );
    this.props.handleClose();
  }

  setIsSaving = (isSaving) => {
    this.setState({ isSaving });
  }

  onModalOk = () => {
    const form = this.props.form;
    this.setIsSaving(true);
    form.validateFields((err, values) => {
      if (err) {
        this.setIsSaving(false);
        return;
      }
      this.sendData(values);
    });
  }

  async sendData(values) {
    const {bookingData: { customMandatoryFieldsInBooking }} = this.props;
    const { inquiryMode, isBooking } = this.props;
    const { licenseFile, licenseFileUrl } = this.state;
    const documents: any = [];
    this.state.fileList.forEach((item) => {
      if (this.state.s3Links[item.uid]) {
        documents.push({
          name: item.name,
          url: this.state.s3Links[item.uid],
          type: 'DO',
        });
      }
    });

    if (!documents?.length && inquiryMode !== 'AIRCARGO' && inquiryMode !== 'DOMESTIC') {
      message.error(`Please upload ${inquiryMode === 'LCL' ? 'Carting Order' : 'the Booking Note'}`);
      this.setIsSaving(false);
      return;
    }

    if ((inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && licenseFile && licenseFileUrl) {
      documents.push({
        name: licenseFile,
        url: licenseFileUrl,
        type: 'DRIVER_LICENSE',
      })
    }
    
    const body = {
      confirmationDetails: {
        etd: values.etd ? +values.etd : undefined,
        eta: values.eta ? +values.eta : undefined,
        bookingNumber: values.bookingNumber ? values.bookingNumber : undefined,
        containerCount: values.containerCount || undefined,
        ...(documents.length && { documents }),
        ...(inquiryMode !== InquiryModes.DOMESTIC && inquiryMode !== InquiryModes.RPTL && {
          ...(!this.props.bookingData?.hidePocDetailsInBooking ? {
            contactDetails: {
              name: values.name,
              phone: values.phone,
              email: values.email || undefined
            },
            yardDetails: values.yardDetails || undefined,
          } : {}),
          vgmCutOff: values.VGMCutOff ? +values.VGMCutOff : undefined,
          documentCutOff: values.documentCutOff ? +values.documentCutOff : undefined,
          portCutOff: values.portCutOff ? +values.portCutOff : undefined,
          siCutOff: values.siCutOff ? +values.siCutOff : undefined,
          gateOpenDate: values.gateOpenDate ? +values.gateOpenDate : undefined,
          billValidity: values.billValidity ? +values.billValidity : undefined,
          houseBl: values.houseBl ? values.houseBl : undefined,
          handoverCutOff: values.handoverCutOff ? +values.handoverCutOff : undefined,
          carrierCode: values.carrierCode || undefined,
          trackingProvider: values.trackingProvider || undefined,
          hblVendor: values.hblVendor || undefined,
          blNumber: values.blNumber || undefined,  
        }),
        ...((inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && {
          purchaseOrder: values?.purchaseOrder ? values.purchaseOrder : undefined,
          truckNumber: values?.truckNumber ? values.truckNumber : undefined,
          driverName: values?.driverName ? values.driverName : undefined,
          driverPhoneNo: values?.driverPhoneNo ? values.driverPhoneNo : undefined,
        }),
      },
      bookingId: this.props.bookingId,
    };
    isBooking && isBooking(true);
    const response = await confirmBooking(body);
    // const response = { isSuccess: true, errorMessage: '' };
    if (response.isSuccess) {
      sendEvent(
        EventCategories.INQUIRY_BOOKING_FF,
        'Booking Confirmed',
      );
      this.setIsSaving(false);
      this.setState({
        protip: true,
      });
    } else {
      message.error(response.errorMessage);
      this.setIsSaving(false);
    }
    isBooking && isBooking(false);
  }

  onOkay = () => {
    this.props.reload();
    this.handleModalClose(false);
    this.setState({
      protip: false,
    });
  }

  s3LinkRequest = async (event) => {
    const { bookingData, form : { setFieldsValue, getFieldsValue } } = this.props;
    const {
      bookingNumber,
      bookingValidity,
      containerCount,
      etd,
      eta,
      portCutOff,
      siCutOff,
      documentCutOff,
    } = getFieldsValue();
    const { file } = event;
    let doExtractedValues;
    const identifier = bookingData?.chargeDetails?.ffCarrier;
    this.setState({
      uploading: true,
    });
    const extension = getFileExtension(file.name);
    const response = await fileUploadOnS3({
      extension,
      fileName: file.name,
      document_type: file.type,
      initialPath: 'inquiry',
    });
    if (response.isSuccess) {
      const upload = await uploadImageToS3(file, response.data.post, extension);
      if (upload.isSuccess) {
        if (isValidArray(carrierListForDOExtraction) &&
          carrierListForDOExtraction.indexOf(identifier) !== -1) {
          const doExtractionResponse = await extractDODetails({
            identifier,
            doS3Link: response.data.get,
          });
          if (doExtractionResponse.isSuccess) {
            doExtractedValues = doExtractionResponse.data;
            setFieldsValue({
              bookingNumber: doExtractedValues?.bookingNumber || bookingNumber,
              billValidity: getDateValue(doExtractedValues?.bookingValidity) || bookingValidity,
              containerCount: doExtractedValues?.totalContainerCount || containerCount,
              etd: getDateValue(doExtractedValues?.etd) || etd,
              eta: getDateValue(doExtractedValues?.eta) || eta,
              portCutOff: getDateValue(doExtractedValues?.gateInCutOff) || portCutOff,
              siCutOff: getDateValue(doExtractedValues?.siCutoff) || siCutOff,
              documentCutOff: getDateValue(doExtractedValues?.documentCutOff) || documentCutOff,
            });
          }
        };
        this.setState({
          doExtractedValues,
          uploading: false,
          s3Links: {
            ...this.state.s3Links,
            [file.uid]: response.data.get,
          },
        });
        event.onSuccess();
        sendEvent(
          EventCategories.INQUIRY_BOOKING_FF,
          'Upload DO',
        );
      } else {
        message.error(upload.errorMessage);
        this.setState({
          uploading: false,
        });
        event.onError();
      }
    } else {
      message.error(response.errorMessage);
      this.setState({
        uploading: false,
      });
      event.onError();
    }
  }

  s3LinkRequestV2 = async ({ file }): Promise<void> => {
    this.setState({
      uploadingLicense: true,
      licenseFile: file.name,
    });
    const extension = getFileExtension(file.name);
    const response = await getS3Links({
      extension,
      fileName: file.name,
      document_type: file.type,
      initialPath: 'inquiry',
    });
    let fileUrl: string = '';
    if (response.isSuccess) {
      const upload = await uploadToS3(response.data.post, extension, file);
      if (upload.isSuccess) fileUrl = response.data.get;
    } else {
      message.error(response.errorMessage);
    }
    this.setState({
      licenseFileUrl: fileUrl,
      uploadingLicense: false,
    });
  };

  handleUploadOnChange = (event) => {
    let fileList = [...event.fileList];
    
    // if (event.file.status === 'done') {
    //   fileList = fileList.map(item => {
    //     if (item.uid in this.state.s3Links) {
    //       item.url = this.state.s3Links[item.uid];
    //     }
    //     return item;
    //   });
    // }
    
    // 1. Limit the number of uploaded files
    // Only to show five recent uploaded files, and old ones will be replaced by the new
    fileList = fileList.slice(-5);
    this.setState({ fileList });
  }

  handleDownload = (file) => {
    downloadS3Url(this.state.s3Links[file.uid], file.name);
  }

  handleDate = (chargeDetails, label) => {
    let initialDate;
    if (chargeDetails?.otherDetails?.[label]) {
      const date = chargeDetails.otherDetails[label];    
      if (typeof date === 'string') {
        initialDate = moment(date);
      } else if (date.dateString && date.time) { 
        initialDate = moment(`${date.dateString} ${date.time}`, 'YYYY-MM-DD HH:mm');
      }
    }
    return initialDate;
  }

  renderProtip = () => {
    return this.state.protip && <Protip
      visible={this.state.protip}
      success={'Congrats'}
      message1={'You have successfully completed the booking process.'}
      message2={'You are being redirected to Bookings'}
      okay={'Okay'}
      onOkay={this.onOkay}
    />;
  }

  renderUploadBookingNote = (label) => {
    const { classes, inquiryMode, bookingData: { customMandatoryFieldsInBooking } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{inquiryMode === 'LCL'
          ? 'Carting Order'
          : label}{inquiryMode === 'AIRCARGO' || inquiryMode === 'DOMESTIC' ? null : <Asterisk />}</div>
        <div style={{ width: '190px' }}>
          <Upload
            fileList={this.state.fileList}
            multiple={true}
            customRequest={event => this.s3LinkRequest(event)}
            onChange={event => this.handleUploadOnChange(event)}
            showUploadList={{showDownloadIcon: true}}
            onDownload={file => this.handleDownload(file)}>
            <Button>
              <Icon type="upload" /> Upload
          </Button>
          </Upload>
        </div>
      </div>
    );
  }

  renderDriverLicense = (label) => {
    const { classes } = this.props;
    const { uploadingLicense, licenseFile } = this.state;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{label}</div>
        <div style={{ width: '190px' }}>
          <Upload
            showUploadList={false}
            multiple={false}
            customRequest={event => this.s3LinkRequestV2(event)}
            disabled={uploadingLicense}>
            <Button loading={uploadingLicense} style={{ borderRadius: `${tokens.radius.md}px` }}>
              <Icon type="upload" /> Upload
            </Button>
          </Upload>
          <div style={{ fontSize: `${tokens.fontSize.small}px`, marginTop: '8px' }}>
            {licenseFile && <React.Fragment>
              <span>{licenseFile}</span>
              <Icon type="close" style={{ color: 'red', marginLeft: '8px' }}
                onClick={() => this.setState({ licenseFile: undefined, licenseFileUrl: undefined })} />
            </React.Fragment>}
          </div>
        </div>
      </div>
    );
  };

  renderGateOpenDate = () => {
    const { classes, form : { getFieldDecorator }, bookingData : { inttraDODetails } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Gate Open Date{this.checkIsMandatory(BOOKING_FORM_FIELDS.gateOpenDate) ? <Asterisk /> : null}</div>
        <FormItem>
          {getFieldDecorator('gateOpenDate', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.gateOpenDate), message: 'Cannot be empty!' }],
            initialValue: inttraDODetails?.gateOpenDate,
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabledDate={this.disabledDateSailing}
              format="DD MMM YYYY | HH:mm"
              style={{ width: '190px' }} placeholder="Gate Open Date" >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  }

  renderYardDetails = () => {
    const { classes, form : { getFieldDecorator }, inquiryMode,
      bookingData : { inttraDODetails } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{inquiryMode === 'LCL'
          ? 'CFS Location'
          : 'Yard Details'}{
            this.checkIsMandatory(BOOKING_FORM_FIELDS.yardDetails) ? <Asterisk /> : null
          }</div>
        <FormItem>
          {getFieldDecorator('yardDetails', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.yardDetails), message: 'Cannot be empty!' }],
            initialValue: inttraDODetails?.yardDetails,
          })(<Input style={{ width: '190px' }} placeholder="Location"
          suffix={<LocationPinIcon />} >
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderVGMCutOff = () => {
    const { classes, form : { getFieldDecorator }, bookingData : { inttraDODetails } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>VGM Cut-off{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.VGMCutOff) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator('VGMCutOff', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.VGMCutOff), message: 'Cannot be empty!' }],
            initialValue: inttraDODetails?.vgmCutOff,
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabledDate={this.disabledDateSailing}
              format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
              placeholder="VGM Cut-off" >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  };

  renderYardAndVGMCutOff = () => {
    return (
      <React.Fragment>
        {this.renderYardDetails()}
        {this.renderVGMCutOff()}
      </React.Fragment>
    );
  }

  renderDocumentCutOff = () => {
    const { classes, form : { getFieldDecorator } } = this.props;
    const { uploading } = this.state;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Document Cut-off{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.documentCutOff) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator('documentCutOff', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.documentCutOff), message: 'Cannot be empty!' }],
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabled={uploading}
              disabledDate={this.disabledDateSailing}
              format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
              placeholder="Document Cut-off" >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  }

  renderCutOffs = () => {
    const { classes, form : { getFieldDecorator }, bookingData : { inttraDODetails, chargeDetails, bookingDetails } } = this.props;
    const { uploading } = this.state;
    return (
      <React.Fragment>
        <div className={classes.pairStyle}>
          <div className={classes.hintHeaderLess}>Gate-in Cut off {
          (this.checkIsMandatory(BOOKING_FORM_FIELDS.gateInCutOff)) ? <Asterisk /> : null}
           </div>
          <FormItem>
            {getFieldDecorator('portCutOff', {
              rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.gateInCutOff), message: 'Cannot be empty!' }],
              initialValue: inttraDODetails?.gateInCutOff,
            })(
              <DatePicker
                showTime={{
                  defaultValue: moment('23:59', 'HH:mm'),
                }}
                disabled={uploading}
                disabledDate={this.disabledDateSailing}
                format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
                placeholder="Gate-in Cut off" >
              </DatePicker>,
            )}
          </FormItem>
        </div>
        <div className={classes.pairStyle}>
          <div className={classes.hintHeaderLess}>SI Cut-off {this.checkIsMandatory(BOOKING_FORM_FIELDS.siCutOff) ? <Asterisk /> : null}</div>
          <FormItem>
            {getFieldDecorator('siCutOff', {
              rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.siCutOff), message: 'Cannot be empty!' }],
              initialValue: (bookingDetails.mode === 'LCL' || bookingDetails.mode === 'FCL') 
              ? this.handleDate(chargeDetails, 'siCutOff')
              : inttraDODetails?.siCutOff,
            })(
              <DatePicker
                showTime={{
                  defaultValue: moment('23:59', 'HH:mm'),
                }}
                disabled={uploading}
                disabledDate={this.disabledDateSailing}
                format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
                placeholder="SI Cut-Off">
              </DatePicker>,
            )}
          </FormItem>
        </div>
      </React.Fragment>
    );
  }

  renderHouseAWBOrBL = () => {
    const { classes, form : { getFieldDecorator, getFieldValue }, inquiryMode } = this.props;
    let inputField =  { label: 'House BL', key: 'houseBl', isMandatory: this.checkIsMandatory(BOOKING_FORM_FIELDS.houseBl) };
    const trackingProvider = getFieldValue('trackingProvider');
    if (trackingProvider === 'SHIPPING_LINE' && Object.keys(MODE_SUPPORTING_AUTO_TRACKING).includes(inquiryMode)) {
      inputField.label = 'BL Number';
      inputField.key = 'blNumber';
      inputField.isMandatory = false;
    }
    if (inquiryMode === 'AIRCARGO') {
      inputField.label = 'House AWB';
    }
    if (trackingProvider === 'HBL_VENDOR') {
      inputField.isMandatory = true;
    }
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{inputField.label}{inputField.isMandatory ? <Asterisk /> : null}</div>
        <FormItem>
          {getFieldDecorator(inputField.key, {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.houseBl),
              pattern: /^[^\s]+$/, message: 'No whitespace allowed' }],
          })(
            <Input style={{ width: '190px' }}
              placeholder={`Enter ${inputField.label}`}>
            </Input>,
          )}
        </FormItem>
      </div>
    );
  }

  renderHandoverCutoff = () => {
    const { classes, form : { getFieldDecorator } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Handover Cut-off{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.handoverCutOff) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator('handoverCutOff', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.handoverCutOff) }],
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabledDate={this.disabledBillValidity}
              format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
              placeholder="Handover Cut-off" >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  };

  renderETD = () => {
    const { classes, form : { getFieldDecorator }, inquiryMode, bookingData : {chargeDetails, bookingDetails} } = this.props;
    const { uploading } = this.state;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'Delivery Date' : 'ETD'}{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.etd) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator('etd', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.etd), message: 'Cannot be empty!' }],
            initialValue: (bookingDetails.mode === 'LCL' || bookingDetails.mode === 'FCL') 
              ? this.handleDate(chargeDetails, 'etd')
              : '',
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabled={uploading}
              disabledDate={this.disabledBillValidity}
              format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
              placeholder={(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'Delivery Date' : 'ETD'} >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  };

  renderETA = () => {
    const { classes, form : { getFieldDecorator }, inquiryMode, bookingData : {chargeDetails, bookingDetails} } = this.props;
    const { uploading } = this.state;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'Pickup Date' : 'ETA'} {this.checkIsMandatory(BOOKING_FORM_FIELDS.eta) ? <Asterisk /> : null}</div>
        <FormItem>
          {getFieldDecorator('eta', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.eta), message: 'Cannot be empty!' }],
            initialValue: (bookingDetails.mode === 'LCL' || bookingDetails.mode === 'FCL') 
              ? this.handleDate(chargeDetails, 'eta')
              : '',
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabled={uploading}
              disabledDate={this.disabledBillValidity}
              format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
              placeholder={(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'Pickup Date' : 'ETA'} >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  };

  renderBookingValidity = (label) => {
    const { uploading } = this.state;
    const { classes, form : { getFieldDecorator }} = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{label}{this.checkIsMandatory(BOOKING_FORM_FIELDS.billValidity) ? <Asterisk /> : null}</div>
        <FormItem>
          {getFieldDecorator('billValidity', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.billValidity), message: 'Cannot be empty!' }],
          })(
            <DatePicker
              showTime={{
                defaultValue: moment('23:59', 'HH:mm'),
              }}
              disabled={uploading}
              disabledDate={this.disabledBillValidity}
              format="DD MMM YYYY | HH:mm" style={{ width: '190px' }}
              placeholder="Booking Validity" >
            </DatePicker>,
          )}
        </FormItem>
      </div>
    );
  };

  renderBookingNumber = (label) => {
    const { classes, form : { getFieldDecorator, getFieldValue }, bookingData : { inttraDODetails } } = this.props;
    const { uploading } = this.state;
    const isMandatory = this.checkIsMandatory(BOOKING_FORM_FIELDS.bookingNumber) || getFieldValue('trackingProvider') === 'SHIPPING_LINE';
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>
          {label}{isMandatory ? <Asterisk /> : null}</div>
        <FormItem>
          {getFieldDecorator('bookingNumber', {
            rules: [{
              required: isMandatory,
              message: 'Cannot be empty!',
            }],
            initialValue: inttraDODetails?.bookingNumber,
          })(
            <Input
              disabled={uploading}
              style={{ width: '190px' }}
              placeholder={label}>
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderContainerCount = () => {
    const { classes, form : { getFieldDecorator }, bookingData, inquiryMode } = this.props;
    const { uploading } = this.state;
    let containerCount = 0;
    bookingData?.bookingDetails?.containerDetails?.forEach(item =>
      containerCount = containerCount + item.count);
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>{(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL)
          ? 'Vehicle' 
          : 'Container'} Count{this.checkIsMandatory(BOOKING_FORM_FIELDS.containerCount) ? <Asterisk /> : null}</div>
        <FormItem>
          {getFieldDecorator('containerCount', {
            initialValue: containerCount,
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.containerCount), message: 'Cannot be empty!'}],
          })(
            <InputNumber
              disabled={uploading}
              style={{ width: '190px' }}
              min={1}
              type="number"
              placeholder={(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? "Vehicle Count" : "Container Count"}>
            </InputNumber>,
          )}
        </FormItem>
      </div>
    );
  };
  
  renderPurchaseOrder = () => {
    const { classes, form : { getFieldDecorator } } = this.props;
    const { uploading } = this.state;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Purchase Order{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.purchaseOrder) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator('purchaseOrder', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.purchaseOrder), message: 'Cannot be empty!' }],
          })(
            <Input disabled={uploading} style={{ width: '190px' }} placeholder="Purchase Order" >
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderVehicleNumber = () => {
    const { classes, form : { getFieldDecorator } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Vehicle Number{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.truckNumber) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator('truckNumber', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.truckNumber), message: 'Cannot be empty!' }],
          })(
            <Input style={{ width: '190px' }} placeholder="Vehicle Number" >
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderName = (key: string) => {
    const { classes, form : { getFieldDecorator } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Name{
          this.checkIsMandatory(BOOKING_FORM_FIELDS[key]) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator(`${key}`, {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS[key]), message: 'Cannot be empty!' }],
          })(
            <Input style={{ width: '190px' }} placeholder="Name" >
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderPhoneInput = (key: string) => {
    const { classes, form : { getFieldDecorator } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Phone{
          this.checkIsMandatory(BOOKING_FORM_FIELDS[key]) ? <Asterisk /> : null
        }</div>
        <FormItem>
          {getFieldDecorator(`${key}`, {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS[key]), message: 'Cannot be empty!' }],
          })(
            <Input style={{ width: '190px' }} placeholder="Phone #" >
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderEmailInput = () => {
    const { classes, form : { getFieldDecorator } } = this.props;
    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Email{
          this.checkIsMandatory(BOOKING_FORM_FIELDS.email) ? <Asterisk /> : null
        }</div>

        <FormItem>
          {getFieldDecorator('email', {
            rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.email), message: 'Cannot be empty!' },
            { pattern: RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/),
              message: 'Please input valid email id' },
            ],
          })(
            <Input style={{ width: '190px' }} placeholder="Email" >
            </Input>,
          )}
        </FormItem>
      </div>
    );
  };

  renderCarrier = () => {
    const { classes, inquiryMode, form : { getFieldDecorator, getFieldValue }, globalShippingLines, globalAirLines, bookingData } = this.props;
    const carrierList = inquiryMode === InquiryModes.AIRCARGO ? globalAirLines : globalShippingLines;
    const carrierSelectedInBid = bookingData?.chargeDetails?.carrierDetails?.id || bookingData?.chargeDetails?.ffCarrier;
    const initialCarrierCode = carrierSelectedInBid !== modeWiseDefaultUndisclosedCarrierCode[inquiryMode] ? carrierSelectedInBid : undefined;

    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>Carrier*</div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
        <FormItem>
          {getFieldDecorator('carrierCode', {
            rules: [{ required: true, message: 'Cannot be empty!' }],
            initialValue: initialCarrierCode,
          })(
            <Select
              style={{ width: '190px' }}
              showSearch
              placeholder="Select Carrier"
              optionFilterProp="children"
              disabled={initialCarrierCode && getFieldValue('carrierCode') &&
              (getFieldValue('carrierCode') !== modeWiseDefaultUndisclosedCarrierCode[inquiryMode])}
            >
              {carrierList?.map(item => item.id !== modeWiseDefaultUndisclosedCarrierCode[inquiryMode] && (
                <Select.Option key={item.id}>{item.name}</Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
        </div>
      </div>
    );
  }

  renderHBLVendor = () => {
    const { classes, form : { getFieldDecorator }, globalCarriers, linkedHblVendor } = this.props;
    const vendorList = globalCarriers?.filter(item => item.type === 'HBL_VENDOR');

    return (
      <div className={classes.pairStyle}>
        <div className={classes.hintHeaderLess}>HBL Vendor*</div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
        <FormItem>
          {getFieldDecorator('hblVendor', {
            rules: [{ required: true, message: 'Cannot be empty!' }],
            ...(linkedHblVendor && {initialValue: linkedHblVendor.id})
          })(
            <Select
              style={{ width: '190px' }}
              showSearch
              disabled={linkedHblVendor}
              placeholder="Select HBL Vendor"
              optionFilterProp="children"
            >
              {vendorList?.map(item => (
                <Select.Option key={item.id}>{item.name}</Select.Option>
              ))}
            </Select>
          )}
        </FormItem>
        </div>
      </div>
    );
  }

  renderTrackingProvider = () => {
    const { classes, form : { getFieldDecorator } } = this.props;
    return (
      <Row className={classes.detailsRow}>
        <Col span={3} className={classes.label}>Tracking Provider</Col>
        <Col span={21}>
          <FormItem className={classes.trackingProviderRadio}>
            {getFieldDecorator('trackingProvider', {
              rules: [{ required: true, message: 'Cannot be empty!' }],
              initialValue: 'SHIPPING_LINE',
            })(
                <RadioGroup
                  options={Object.keys(trackingProviders).map((item) => ({
                    key: item,
                    label: trackingProviders[item],
                  }))}
                />
              )
            }
          </FormItem>
        </Col>
      </Row>
    );
  };

  renderBookingDetails = () => {
    const { classes, inquiryMode, form : { getFieldValue } } = this.props;
    return (
      <Row className={classes.detailsRow}>
        <Col span={3} className={classes.label}>Booking Details</Col>
        <Col span={21}>
          <Col span={8}>
            {inquiryMode !== InquiryModes.DOMESTIC && inquiryMode !== InquiryModes.RPTL && (getFieldValue('trackingProvider') === 'HBL_VENDOR' 
              ? this.renderHBLVendor() 
              : this.renderCarrier())
            }
            {(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && this.renderETA()}
            {(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && this.renderETD()}
            {this.renderUploadBookingNote('Booking Note')}
            {inquiryMode === 'AIRCARGO' && this.renderBookingValidity('Booking Validity')}
            {inquiryMode !== InquiryModes.DOMESTIC && inquiryMode !== InquiryModes.RPTL && this.renderHouseAWBOrBL()}
          </Col>
          <Col span={3}></Col>
          <Col span={8}>
            {this.renderBookingNumber((inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'Booking Reference' : 'Booking Number')}
            {(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && this.renderPurchaseOrder()}
            {this.renderContainerCount()}
            {(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && this.renderVehicleNumber()}
          </Col>
        </Col>
      </Row>
    );
  };

  getModeWiseCutOffs = () => {
    const { inquiryMode } = this.props;
    if (inquiryMode === 'AIRCARGO') {
      return (
        <React.Fragment>
          <Col span={8}>
            {this.renderGateOpenDate()}
            {this.renderDocumentCutOff()}
            {this.renderETA()}
          </Col>
          <Col span={3}></Col>
          <Col span={8}>
            {this.renderHandoverCutoff()}
            {this.renderETD()}
          </Col>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <Col span={8}>
          {this.renderVGMCutOff()}
          {this.renderDocumentCutOff()}
          {this.renderETD()}
          {this.renderBookingValidity('Booking Valid Till')}
        </Col>
        <Col span={3}></Col>
        <Col span={8}>
          {this.renderCutOffs()}
          {this.renderETA()}
          {this.renderGateOpenDate()}
        </Col>
      </React.Fragment>
    );
  };

  renderCutOffsDetails = () => {
    const { classes, inquiryMode } = this.props;
    return (
      <Row className={classes.detailsRow}>
        <Col span={3} className={classes.label}>Cut-Offs</Col>
        <Col span={21}>
          <Row>
            {this.getModeWiseCutOffs()}
          </Row>
        </Col>
      </Row>
    );
  };

  renderContactDetails = () => {
    const { classes, inquiryMode } = this.props;
    return (
      <Row className={classes.detailsRow}>
        <Col span={3} className={classes.label}>{(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'Driver' : 'Contact'} Details</Col>
        <Col span={7}>
          {this.renderName((inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'driverName' : 'name')}
          {this.renderPhoneInput((inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) ? 'driverPhoneNo' : 'phone')}
          {inquiryMode !== InquiryModes.DOMESTIC && inquiryMode !== InquiryModes.RPTL && this.renderEmailInput()}
          {(inquiryMode === InquiryModes.DOMESTIC || inquiryMode === InquiryModes.RPTL) && this.renderDriverLicense('License')}
        </Col>
      </Row>
    );
  };

  renderLocationDetails = () => {
    const { classes, form : { getFieldDecorator }, inquiryMode } = this.props;
    return (
      <Row>
        <Col span={3} className={classes.label} style={{ marginTop: '5px' }}>Location Details</Col>
        <Col span={10} className={classes.pairStyle} style={{ marginTop: '10px', alignItems: 'unset' }}>
          <div className={classes.hintHeaderLess} style={{ width: '25%' }}>{inquiryMode === 'LCL'
            ? 'CFS Location'
            : 'Yard Details'}{
            this.checkIsMandatory(BOOKING_FORM_FIELDS.yardDetails) ? <Asterisk /> : null
            }</div>
          <FormItem style={{ width: '72%' }}>
            {getFieldDecorator('yardDetails', {
              rules: [{ required: this.checkIsMandatory(BOOKING_FORM_FIELDS.yardDetails), message: 'Cannot be empty!' }],
            })(
              <TextArea style={{ width: '100%' }} placeholder="Location" rows={3} />,
            )}
          </FormItem>
        </Col>
      </Row>
    );
  };

  renderProcessBookingNoteData = () => {
    const { inquiryMode, handleClose} = this.props;
    return (
      <React.Fragment>
        {Object.keys(MODE_SUPPORTING_AUTO_TRACKING).includes(inquiryMode) && this.renderTrackingProvider()}
        {this.renderBookingDetails()}
        {inquiryMode !== InquiryModes.DOMESTIC && inquiryMode !== InquiryModes.RPTL && this.renderCutOffsDetails()}
        {(!this.props.bookingData?.hidePocDetailsInBooking || inquiryMode === 'DOMESTIC' || inquiryMode === 'RPTL') && this.renderContactDetails()}
        {!this.props.bookingData?.hidePocDetailsInBooking && (inquiryMode !== 'AIRCARGO' && inquiryMode !== 'DOMESTIC' && inquiryMode !== 'RPTL') && this.renderLocationDetails()}
        {this.renderProtip()}
      </React.Fragment>
    );
  };

  render() {
    const { isSaving } = this.state;
    const { isVisible, classes, bookingData, isProcessBookingForm, handleBack } = this.props;
    let containerCount = 0;
    bookingData?.bookingDetails?.containerDetails?.forEach(item =>
      containerCount = containerCount + item.count);

    if (isProcessBookingForm) {
      return (
        <div style={{ marginTop: '20px', padding: '24px' }}>
          {this.renderProcessBookingNoteData()}
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            borderTop: '1px solid rgb(151,151,151, 0.2)',
            paddingTop: '24px',
            marginTop: '36px',
          }}>
            <a style={{ color: tokens.colors.primary, fontSize: `${tokens.fontSize.h3}px` }}
              onClick={handleBack}>Previous</a>
            <Button
              loading={isSaving}
              type="primary"
              style={{ backgroundColor: tokens.colors.primary, border: tokens.colors.primary, marginRight: '70px' }}
              onClick={this.onModalOk}>
                Submit Booking
            </Button>
          </div>
        </div>
      )
    }
    return (
      <Modal
        title="Upload Booking Note"
        visible={isVisible}
        className={classes.modal}
        onCancel={() => !isSaving && this.handleModalClose()}
        footer={
          <Button
            className={classes.submitButton}
            onClick={this.onModalOk}
            loading={isSaving}
          >Submit</Button>
        }
      >
        {this.renderProcessBookingNoteData()}
      </Modal>
    );
  }
}

const mapStateToProps = ({ masterData }, { }) => ({
  globalShippingLines: masterData.globalShippingLines,
  globalCarriers: masterData.globalCarriers,
  globalAirLines: masterData.globalAirLines,
  linkedHblVendor: masterData?.linkedHblVendor,
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators({
    reload: setPrevPagination(ownProps.type),
  }, dispatch);
};

// export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Form.create()(StyledBookingFFModal)));

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const StyledBookingFFModal = injectSheet(styles)(BookingFFModal);
export default connector((withRouter(Form.create()(StyledBookingFFModal))));